// extracted by css-extract-rspack-plugin
export default {"usage":"pvTuS","toggle":"EFLXk","chevron":"hYyd3","open":"wCVwc","arg":"y2rjl","active":"y6k1B","info":"WGapf","title":"NV1pA","arguments":"rmvqV","documentationLink":"nUgK8"};